import React from 'react'

interface CanvasWindowRestoreIconProps {
  size?: number
  className?: string
}

/**
 * „Aufgabenliste einblenden" — linkes Segment der Fenster-Umschaltgruppe im
 * maximierten Zustand (Figma `btn Restore Sidebar` 4872:100233). Dasselbe
 * Zeichen trägt der Öffnen-Knopf der geschlossenen Werkzeug-Pille (Figma
 * `btn Canvas Toolbar Expand` 4916:265209, gleiche Geometrie).
 *
 * Derselbe Rahmen wie {@link CanvasWindowCloseIcon}, darin der gefüllte
 * Seitenbalken. Figma zeichnet ihn als 3×8-Fläche MIT 1.33er Kontur; hier
 * steht stattdessen eine einzelne gefüllte Fläche in den Außenmaßen dieser
 * Kontur (4.33×9.33) — optisch identisch, und es bleibt bei einer Farbe.
 */
export const CanvasWindowRestoreIcon: React.FC<CanvasWindowRestoreIconProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.335"
      y="2.335"
      width="17.33"
      height="15.33"
      rx="4.665"
      stroke="currentColor"
      strokeWidth="1.33"
    />
    <rect x="11.335" y="5.335" width="4.33" height="9.33" rx="1.87" fill="currentColor" />
  </svg>
)
